module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "jumbotron text-xs-center"
  }, [(_vm.isConfirmed) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Pronto!")]), _vm._v(" "), _c('h3', {
    staticClass: "display-5"
  }, [_vm._v("Sua submissão "), _c('strong', [_vm._v(_vm._s(_vm.requestId))]), _vm._v(" foi recebida com sucesso!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.requestEndMessage) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.requestEndMessage)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n              Encontrou problemas? "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.mailContact
    }
  }, [_vm._v("Contacte-nos")])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "role": "button",
      "to": {
        name: 'UserProfile'
      }
    }
  }, [_vm._v("Ir para a página inicial")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-danger",
    attrs: {
      "role": "button",
      "to": "/login?ex=1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("Sair do sistema")])], 1)]), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Ops")]), _vm._v(" "), _c('h3', {
    staticClass: "display-5"
  }, [_vm._v("Algo deu errado e não foi possível confirmar a submissão!")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n              Encontrou problemas? "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.mailContact
    }
  }, [_vm._v("Contacte-nos")])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "role": "button",
      "to": {
        name: 'UserProfile'
      }
    }
  }, [_vm._v("Ir para a página inicial")])], 1)]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_c('strong', [_vm._v("Favor checar seu e-mail")]), _vm._v(" com os detalhes da sua inscrição.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok-circle success"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_c('strong', [_vm._v("Favor tentar novamente.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle fail"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acf6c342"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestConfirmation.vue
// module id = 1415
// module chunks = 1